import styled from '@emotion/styled';
import { translateInComponent } from 'infras/i18n';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import { memo, useContext, useMemo } from 'react';
import translations from './i18n.json';
import { CalendarContext } from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';
import { gray01, gray02 } from 'presentations/views/styles/color';
import { horizontalRulerWidth } from '../reducer';

interface Props {}

const Component = memo((props: Props) => {
  const t = translateInComponent(translations);
  const { state } = useContext(CalendarContext);
  const rows = state.isDisableMultiTimeZones ? 0 : state.rulerTimeZones.length;
  const width = horizontalRulerWidth * (rows + 1);
  return (
    <Ruler width={width}>
      <RulerCell>{t('All Day')}</RulerCell>
    </Ruler>
  );
});

const Ruler = styled.div<{ width: number }>`
  width: ${(props) => `${props.width}px`};
`;
const RulerCell = styled.div`
  height: 20px;
  color: ${gray02};
  font-size: ${fontSize(10)};
  font-weight: ${fontWeight('bold')};
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: ${spacing(2)} ${spacing(8)} 0 0;
`;

export default Component;
